// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Aside: MarkdocTagRegistration = {
  tag: 'aside',
  component: 'Aside',
  description: 'Display the enclosed content in a box alongside the document',
  children: ['paragraph', 'tag', 'list'],
  attributes: {
    title: {
      type: String,
      description: 'The title displayed at the top of the aside',
      localizable: true,
    },
    wide: {
      type: Boolean,
      description: 'Set to true for a wider version of aside',
      default: false,
    },
  },
};
